export const column2object = (columns: any) => {
  return {
    disabled: columns[2],
    key: columns[3],
  }
}
